import { render } from "./Backdrop.vue?vue&type=template&id=5d251ec7&scoped=true"
import script from "./Backdrop.vue?vue&type=script&lang=js"
export * from "./Backdrop.vue?vue&type=script&lang=js"

import "./Backdrop.vue?vue&type=style&index=0&id=5d251ec7&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d251ec7"]])

export default __exports__